export default __webpack_public_path__ + "static/media/ODToro.82fd495e.png";